import PromoCodesContainer from "@/Marketing/PromoCodesContainer.vue";

export default [
  {
    path: "/discounts",
    name: "PromoCodesContainer",
    component: PromoCodesContainer,
    meta: {
      permissionRoles: ["promo_codes_report"]
    }
  }
];
